import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

export const fertilizationRoutes: Route = {
    path: 'fertilization',
    data: { title: 'fertilization' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'agro-cares-crop-match' },
        {
            path: 'soil-analysis-sendable-reports',
            loadComponent: () =>
                import('../soil-analysis-sendable-reports/soil-analysis-sendable-reports.component').then(
                    (m) => m.SoilAnalysisSendableReportsComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Soil analysis sendable reports' },
        },
        {
            path: 'agro-cares-crop-match',
            loadComponent: () =>
                import('./agro-cares-crop-match/agro-cares-crop-match.component').then((m) => m.AgroCaresCropMatchComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares crop match' },
        },
        {
            path: 'agro-cares-fertilization-advise',
            loadComponent: () =>
                import('./agro-cares-fertilization-organic-matter-advise/agro-cares-fertilization-organic-matter-advise.component').then((m) => m.AgroCaresFertilizationOrganicMatterAdviseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares fertilization advise' },
        },
        {
            path: 'agro-cares-fertilization-content',
            loadComponent: () =>
                import('./agro-cares-fertilization-content/agro-cares-fertilization-content.component').then(
                    (m) => m.AgroCaresFertilizationContentComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares fertilization element' },
        },
        {
            path: 'agro-cares-fertilization-initialization',
            loadComponent: () =>
                import('./agro-cares-fertilization-initialization/agro-cares-fertilization-initialization.component').then((m) => m.AgroCaresFertilizationInitializationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares fertilization initialization' },
        },
        {
            path: 'agro-cares-fertilization-organic-matter-advise',
            loadComponent: () =>
                import('./agro-cares-fertilization-organic-matter-advise/agro-cares-fertilization-organic-matter-advise.component').then((m) => m.AgroCaresFertilizationOrganicMatterAdviseComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares fertilization organic matter advise' },
        },
        {
            path: 'agro-cares-fertilization-program',
            loadComponent: () =>
                import('./agro-cares-fertilization-program/agro-cares-fertilization-program.component').then(
                    (m) => m.AgroCaresFertilizationProgramComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares fertilization program' },
        },
        {
            path: 'agro-cares-phenological-stage',
            loadComponent: () =>
                import('./agro-cares-phenological-stage/agro-cares-phenological-stage.component').then(
                    (m) => m.AgroCaresPhenologicalStageComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares phenological stage' },
        },
        {
            path: 'agro-cares-distribution',
            loadComponent: () =>
                import('./agro-cares-distribution/agro-cares-distribution.component').then(
                    (m) => m.AgroCaresDistributionComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares distribution' },
        },
        {
            path: 'agro-cares-report',
            loadComponent: () =>
                import('./agro-cares-report/agro-cares-report.component').then((m) => m.AgroCaresReportComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares report' },
        },
        {
            path: 'agro-cares-report-parameter',
            loadComponent: () =>
                import('./agro-cares-report-parameter/agro-cares-report-parameter.component').then(
                    (m) => m.AgroCaresReportParameterComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares report parameter' },
        },
        {
            path: 'agro-cares-report-feed',
            loadComponent: () =>
                import('./agro-cares-report/agro-cares-report.component').then((m) => m.AgroCaresReportComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Agro cares report feed' },
        },
    ],
};
